/** KM 流程 my-act172.km-susun-atur 1.0.0 的词汇（规划第三阶段，计划 P3-3b D-153）。 */
export default {
  stage: {
    osc_screening: 'OSC 预审',
    screening_returned: '预审退回',
    awaiting_registration: '待登记',
    cancelled: '已取消',
    technical_review: '技术审查',
    written_direction: '已发出书面指示（A1 表格）',
    rechecking: '复查修订图纸',
    neighbour_notice: '邻里通知与异议',
    recommendation: '建议文件',
    committee: 'OSC 委员会（JK OSC）',
    plan_amendment: '图纸修订（LDPP）',
    amendment_checking: '检查修订图纸',
    mpfn_referral: '已转介 JPN 与 MPFN',
    approved_pending_issue: '已批准，待签发',
    final_plan_checking: '检查最终图纸',
    refusal_pending: '已拒绝，待发出拒绝信',
    granted: '已核准',
    extension_pending: '已申请延期',
    commenced: '工程已开工',
    completed: '已竣工',
    lapsed: '已失效',
    refused: '已拒绝（上诉期内）',
    under_appeal: '上诉中',
    refused_final: '已拒绝（最终）',
    deemed_withdrawn: '视为撤回',
    escalated_to_state: '已提交州政府',
  },
  actions: {
    amend_check_errored: '修订图纸检查无法运行',
    amend_check_failed: '修订图纸检查未通过',
    amend_check_passed: '修订图纸检查通过',
    amend_check_retry: '重新检查修订图纸',
    amendment_lapsed: '记录修订期限已过',
    amendment_submit: '提交修订图纸',
    appeal_allowed: '记录上诉获准',
    appeal_dismissed: '记录上诉被驳回',
    appeal_grant_decided: '记录针对核准的上诉决定',
    appeal_grant_decided_commenced: '记录针对核准的上诉决定（已开工）',
    appeal_grant_lodged: '记录针对核准的上诉',
    appeal_grant_lodged_commenced: '记录针对核准的上诉（已开工）',
    appeal_grant_set_aside: '记录核准经上诉被撤销',
    appeal_lodge: '记录已提出上诉',
    appeal_window_closed: '上诉期已结束',
    approval_issue: '签发建筑图批准',
    approval_void_with_parent: '随已失效的规划许可作废',
    bp_direction_deemed_withdrawn: '视为撤回：错过修订期限',
    bp_direction_extend: '延长修订期限',
    bp_direction_reinstate: '恢复建筑图案件',
    c1_issue: '签发 C1 表格',
    c2_issue: '签发 C2 表格',
    charge_record: '记录发展费',
    check_accept_exceptions: '附例外接受检查',
    circulate: '分发给机构',
    committee_approve: '记录委员会批准',
    committee_approve_with_amendments: '记录附图纸修订的批准（LDPP）',
    committee_cancel: '记录委员会取消',
    committee_carry_over: '移至下次会议',
    committee_refuse: '记录委员会拒绝',
    committee_table: '提交 OSC 委员会',
    condition_complied: '记录已遵守的条件',
    construction_complete: '记录竣工（CCC）',
    construction_start: '记录开工（B 表格）',
    decision_finalise: '拒绝成为最终决定',
    delegated_approve: '依授权批准',
    delegated_refuse: '依授权拒绝',
    direction_comply: '记录遵守指示（A2 表格）',
    direction_deemed_withdrawn: '视为撤回：未遵守指示',
    direction_extend: '延长指示期限',
    direction_issue: '发出书面指示（A1 表格）',
    direction_reinstate: '恢复案件',
    escalate_to_state: '记录提交州政府',
    extension_circulate: '将延期分发给机构',
    extension_recommend: '就延期提出建议',
    final_check_errored: '最终图纸检查无法运行',
    final_check_failed: '最终图纸检查未通过',
    final_check_passed: '最终图纸检查通过',
    final_check_retry: '重新检查最终图纸',
    final_plans_submit: '提交最终图纸',
    hearing_held: '记录异议听证',
    ldpp_letter_issued: '记录已发出修订函',
    mpfn_advised: '记录 MPFN 意见',
    mpfn_refer: '转介 JPN 与 MPFN',
    neighbours_notify: '通知邻居',
    objection_record: '记录异议',
    objections_closed: '异议期已结束',
    paper_submit: '提交建议文件',
    paper_submit_after_notice: '通知后提交建议文件',
    parent_withdrawn: '随已撤回的规划许可撤回',
    permit_apply_extension: '申请延期',
    permit_extend: '批准延期',
    permit_lapse: '许可已失效',
    permit_refuse_extension: '拒绝延期',
    permit_renew: '记录续期',
    prerequisite_record: '记录核对清单项目',
    recheck_errored: '复查无法运行',
    recheck_failed: '复查未通过',
    recheck_passed: '复查通过',
    recheck_retry: '重新复查',
    refusal_issue: '发出拒绝信',
    register: '登记',
    register_building: '登记建筑图',
    screen_cancel: '取消：错过补件期限',
    screen_complete: '预审完成',
    screen_expired: '补件期限已过',
    screen_incomplete: '以不完整退回',
    state_approved: '记录州政府批准',
    state_refused: '记录州政府拒绝',
    withdrawal_close: '结束撤回',
  },
  inputs: {
    advice: '意见摘要',
    advisedOn: '意见日期',
    amendments: '所需修订',
    appealRef: '上诉编号',
    appealResult: '上诉结果',
    appellant: '上诉人',
    approvalNo: '批准函编号',
    approvedOn: '批准日期',
    boardOrderRef: '上诉委员会命令编号',
    borangBStatus: '规划许可的 B 表格状态',
    c1No: 'C1 表格编号',
    chargeAmount: '收费金额（令吉）',
    chargeReceipt: '收费收据编号',
    chargeStatus: '发展费',
    commencedOn: '开工日期（B 表格）',
    communicatedOn: '通知申请人的日期',
    completedOn: '竣工日期（CCC）',
    conditionIds: '已遵守的条件',
    conditions: '条件',
    decidedOn: '决定日期',
    delegated: '依授权决定',
    directions: '指示内容',
    evidence: '证明',
    extendedOn: '延期日期',
    extraDays: '额外天数',
    feeReceipt: '费用收据编号',
    filing: '提交方式',
    grounds: '理由',
    hardcopyVerified: '纸本已核对',
    heldOn: '听证日期',
    isf: '基础设施分摊费（ISF）已缴',
    issuedOn: '签发日期',
    kmScale: '规划许可规模',
    kmValid: '规划许可有效',
    letterOn: '函件日期',
    lodgedOn: '提出日期',
    meetingNo: '会议编号',
    meetingOn: '会议日期',
    noBuildingWorks: '无建筑工程',
    noLocalPlan: '无生效的地方规划',
    note: '备注',
    objectionReceivedOn: '收到异议的日期',
    objector: '异议人',
    objectorNoticeOn: '通知异议人的日期',
    orderOn: '命令日期',
    period: '期限（天）',
    pjp: 'PJP 已办妥',
    pkt: 'PKT 已办妥',
    praJkOn: '委员会预备会议日期',
    proposedConditions: '建议条件',
    receiptOn: '收到日期',
    receivedOn: '收到日期',
    refusalRef: '拒绝信编号',
    refusedOn: '拒绝日期',
    registeredOn: '登记日期',
    renewalRef: '续期编号',
    renewedOn: '续期日期',
    s18Deposit: '第 18 条押金或豁免',
    scale: '规模',
    scheduledOn: '计划会议日期',
    servedOn: '送达日期',
    stampingPlans: '已收到待盖章图纸',
    stateDecidedOn: '州政府决定日期',
    stateRef: '州政府函件编号',
    stateRefusalRef: '州政府拒绝函编号',
    summary: '摘要',
    syor: '建议',
    window: '意见期限（天）',
    worksNotStopped: '工程停工未超过三个月',
  },
  clocks: {
    osc_screening: 'OSC 预审',
    applicant_completion: '申请人补件',
    circulation: '分发给机构',
    technical_comment: '机构意见',
    kpkt_first_hearing: '首次听证（KPKT）',
    kpkt_decision: '决定（KPKT）',
    paper_due: '建议文件期限',
    written_direction: '书面指示（A2 表格）',
    neighbour_objection: '邻里异议',
    objection_hearing: '异议听证',
    ldpp_amendment: '图纸修订（LDPP）',
    bp_direction: '建筑图修订',
    bp_decision_window: '建筑图决定（三个月）',
    reinstate_window: '恢复期限',
    documentation: '批准后文件',
    appeal_window: '上诉期',
    appeal_grace: '逾期上诉宽限期',
    appeal_window_grant: '针对核准的上诉期',
    validity: '有效期',
  },
  flags: {
    scale: '规模',
    noLocalPlan: '无生效的地方规划',
    noticeRequired: '须通知邻居',
    delegated: '授权途径',
    noBuildingWorks: '无建筑工程',
    amendmentLapsed: '修订期限已过',
    filing: '提交方式',
    objectionsClosed: '异议期已结束',
    hearingSettled: '听证已完成',
    committeeOutcome: '委员会决定',
    chargeStatus: '发展费',
    chargeSettled: '发展费已办妥',
    stampingPlans: '已收到待盖章图纸',
    isf: 'ISF 已缴',
    kmValid: '规划许可有效',
    pjp: 'PJP 已办妥',
    pkt: 'PKT 已办妥',
    s18Deposit: '第 18 条押金或豁免',
    grantAppealOpen: '针对核准的上诉进行中',
    extensionRecommended: '已建议延期',
    appealAllowed: '上诉获准',
  },
  counters: {
    hearings: '听证次数',
    objections: '异议数',
    extensions: '延期次数',
    ldppLetters: '修订函数',
    directionExtensions: '指示延期次数',
    bpDirectionExtensions: '建筑图修订延期次数',
    renewals: '续期次数',
  },
  /** Design Q26 (decided 2026-10-29): the form's notice beside `nama` and `pemaju`; awaits a native speaker's review. */
  form: {
    registerNotice: '开发商名称和开发项目名称将在已承诺土地用途登记册（Guna Tanah Komited）中报送 PLANMalaysia。',
  },
} as const
